import * as Yup from 'yup';

export const validationSchema = Yup.object({
  description: Yup.mixed().test('Popis', '', function (value) {
    const newOrder = this.options.parent || {};

    const { archivalUnits, description = '' } = newOrder;

    const shortDescription = description.length < 10;

    if ((archivalUnits == null || archivalUnits.length === 0) && shortDescription) {
      return this.createError({
        path: 'description',
        message: 'Předmět objednávky musí obsahovat nejméně 10 znaků',
      });
    }

    return false;
  }),
});
